import { getSlugFromPage } from '@eliadmin/core/src/utils/url-utils';

export const ROUTES_OVERRIDES = {
  PAYMENT_OPTIONS: () => getSlugFromPage('payment-options'),
};
